// extracted by mini-css-extract-plugin
export default {"container":"header-page_container__adxp-","title":"header-page_title__os+hG"};